import { Modal as AntModal } from "antd";
import { Modal as MobileModal } from "antd-mobile";
import { useCurrentBreakpointName } from "react-socks";
import React from "reactn";
import styled from "styled-components";

export const LoginModal = ({
	visible,
	children,
	closable,
	size,
	destroyOnClose,
	onCancel,
}) => {
	const breakpoint = useCurrentBreakpointName();

	if (breakpoint === "mobile") {
		return (
			<AntModal
				size={size}
				visible={visible}
				footer={false}
				onCancel={onCancel}
				destroyOnClose={true}
				maskClosable={false}
			>
				<div style={{ padding: "20px" }}>{children}</div>
			</AntModal>
		);
	}

	return (
		<AntModal
			style={{ top: 0 }}
			visible={visible}
			footer={null}
			destroyOnClose={true}
			onCancel={onCancel}
			maskClosable={false}
		>
			<div style={{ padding: "20px" }}>{children}</div>
		</AntModal>
	);
};
